// extracted by mini-css-extract-plugin
var _1 = "webpack-concepts-Extraction-StudyList-UnmergeStudiesModal-module__cancel";
var _2 = "webpack-concepts-Extraction-StudyList-UnmergeStudiesModal-module__heading";
var _3 = "webpack-concepts-Extraction-StudyList-UnmergeStudiesModal-module__modalFooter";
var _4 = "webpack-concepts-Extraction-StudyList-UnmergeStudiesModal-module__title";
export { _1 as "cancel", _2 as "heading", _3 as "modalFooter", _4 as "title" }
